import { render, staticRenderFns } from "./SearchSpeechs.html?vue&type=template&id=49fb99ec&scoped=true&"
import script from "./SearchSpeechs.js?vue&type=script&lang=js&"
export * from "./SearchSpeechs.js?vue&type=script&lang=js&"
import style0 from "./SearchSpeechs.scss?vue&type=style&index=0&id=49fb99ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fb99ec",
  null
  
)

export default component.exports